import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const clearRemainingTC = async ({ testSuiteId }) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=clearRemainingTC&companyId=${user.companyid}&testSuiteId=${testSuiteId}`
  );

  return response.data;
};

const useClearRemainingTCsMutation = (options = {}) => {
  return useMutation({
    mutationFn: clearRemainingTC,
    ...options,
  });
};

export default useClearRemainingTCsMutation;
